import createHistory from 'history/createBrowserHistory';


export default createHistory();


// WEBPACK FOOTER //
// ./src/history.js